import _ from "lodash";
import React, { useRef, useState } from "react";
import { useMutation } from "react-query";
import styled from "styled-components";
import Buttons from "../../../../components/atoms/Buttons";
import { StatusType } from "../../../../components/atoms/Explain/types";
import TextInputs from "../../../../components/atoms/Inputs/TextInputs";
import { ALERT_MESSAGE } from "../../../../components/constants";
import InputLines from "../../../../components/molecures/InputLines";
import Modal from "../../../../components/molecures/Modals/Modal";
import { SendPhoneNumber } from "../../../../components/molecures/PhoneInput/apis";
import useModals from "../../../../hooks/useModals";
import { HttpError } from "../../../../network/types";
import {
  alertSuccess,
  alertError,
  validatePhone,
} from "../../../../shared/utils";
import { theme } from "../../../../theme";

import { CheckPhoneAuth } from "../../../../apis/Login/apis";
import { CONFIRM_MODAL_EXPLAIN, CONFIRM_MODAL_TITLE } from "../../constants";

interface Props {
  managerPhone: string;
  setFieldValue: any;
}
const ChangePhoneModal: React.FC<Props> = ({ managerPhone, setFieldValue }) => {
  const { openAlertModal, resetModal, openConfirmModal } = useModals();
  const sendPhoneMutation = useMutation(SendPhoneNumber, {
    onSuccess: (res) => {
      setSendPhone(true);
      setFieldValue({ authTokenId: res.authTokenId });
      setAuthTokenId(res.authTokenId);
      alertSuccess(ALERT_MESSAGE.PHONE_SEND);
    },
    onError: (err: HttpError) => {
      alertError(err.message);
    },
  });

  const checkPhoneTokenMutation = useMutation(CheckPhoneAuth, {
    onSuccess: (res) => {
      setFieldValue({
        accessToken: res.accessToken,
        managerPhone: newPhone,
      });
      resetModal();
      openAlertModal({
        contents: (
          <div>
            {CONFIRM_MODAL_EXPLAIN.PHONE_CHANGE}
            <br />
            저장하기를 눌러주세요
          </div>
        ),
        title: CONFIRM_MODAL_TITLE.PHONE_CHANGE,
      });
    },
    onError: (err: HttpError) => {
      alertError(err.message);
    },
  });

  // authTokenId: res.authTokenId,
  // accessToken: "",
  // code: "",
  const [status, setStatus] = useState<{
    phone: { status?: StatusType; explain?: string };
    authToken: { status?: StatusType; explain?: string };
  }>({
    phone: {
      status: undefined,
      explain: undefined,
    },
    authToken: {
      status: undefined,
      explain: undefined,
    },
  });

  const [isSendPhone, setSendPhone] = useState(false);
  const [authTokenId, setAuthTokenId] = useState("");
  const [authToken, setAuthToken] = useState("");
  const [newPhone, setNewPhone] = useState("");
  const authRef = useRef<any>(null);
  const phone = `${managerPhone.slice(0, 3)}-${managerPhone.slice(
    3,
    7
  )}-${managerPhone.slice(7, 11)}`;
  const onOk = () => {
    if (newPhone === managerPhone)
      setStatus({
        ...status,
        phone: {
          status: "error",
          explain: "기존 휴대폰 번호와 똑같은 번호로 변경할 수 없습니다",
        },
      });
    else if (validatePhone(newPhone))
      openConfirmModal({
        contents: "휴대폰 번호를 변경하시겠습니까?",
        title: "휴대폰 번호 변경",
        onOk: () =>
          checkPhoneTokenMutation.mutate({
            key: newPhone,
            authTokenId,
            token: authToken,
          }),
      });
  };
  const debouncedPhoneSend = _.debounce(() => {
    sendPhoneMutation.mutate({ key: newPhone });
    if (authRef.current) if (authRef.current.focus) authRef.current.focus();
  }, 400);
  return (
    <Modal
      width={700}
      onOk={onOk}
      onCancel={resetModal}
      onAdditional={resetModal}
      isOkDisabled={
        managerPhone === newPhone || newPhone === "" || authToken === ""
      }
      title="휴대폰 번호 변경"
    >
      <ModalContainer>
        <StyledCurrentPhoneWrapper>
          <StyledTitle>현재 휴대폰 번호</StyledTitle>
          <StyledPhone>{phone}</StyledPhone>
        </StyledCurrentPhoneWrapper>
        <InputLines alignStart margin="24px" isFill title="새 휴대폰 번호">
          <StyledPhoneAuthWrapper>
            <TextInputs
              onPressEnter={
                managerPhone === newPhone
                  ? () =>
                      setStatus({
                        ...status,
                        phone: {
                          status: "error",
                          explain:
                            "기존 휴대폰 번호와 똑같은 번호로 변경할 수 없습니다",
                        },
                      })
                  : validatePhone(newPhone)
                  ? debouncedPhoneSend
                  : () => {
                      setStatus({
                        ...status,
                        phone: {
                          status: "error",
                          explain: ALERT_MESSAGE.WRONG_PHONE,
                        },
                      });
                    }
              }
              status={status.phone.status}
              explain={status.phone.explain}
              value={newPhone}
              onChange={(e) => {
                setNewPhone(e);
                setStatus({
                  ...status,
                  phone: {
                    status: validatePhone(e) ? undefined : "error",
                    explain: validatePhone(e)
                      ? undefined
                      : ALERT_MESSAGE.WRONG_PHONE,
                  },
                });
                if (managerPhone === e) {
                  setStatus({
                    ...status,
                    phone: {
                      status: "error",
                      explain:
                        "기존 휴대폰 번호와 똑같은 번호로 변경할 수 없습니다",
                    },
                  });
                }
              }}
              placeholder="새 휴대폰번호"
            />
            <StyledButtonWrapper>
              <Buttons
                text={isSendPhone ? "재전송" : "인증하기"}
                disabled={status.phone.status === "error" || !newPhone}
                onClick={
                  managerPhone === newPhone
                    ? () =>
                        setStatus({
                          ...status,
                          phone: {
                            status: "error",
                            explain:
                              "기존 휴대폰 번호와 똑같은 번호로 변경할 수 없습니다",
                          },
                        })
                    : validatePhone(newPhone)
                    ? debouncedPhoneSend
                    : () => {
                        setStatus({
                          ...status,
                          phone: {
                            status: "error",
                            explain: ALERT_MESSAGE.WRONG_PHONE,
                          },
                        });
                      }
                }
              />
            </StyledButtonWrapper>
          </StyledPhoneAuthWrapper>
        </InputLines>
        <InputLines alignStart margin="24px" isFill title="인증번호">
          <TextInputs
            ref={authRef}
            status={status.authToken.status}
            explain={status.authToken.explain}
            value={authToken}
            onChange={(e) => {
              setAuthToken(e);
              setStatus({
                ...status,
                authToken: { status: undefined, explain: undefined },
              });
            }}
            placeholder="인증번호"
          />
        </InputLines>
      </ModalContainer>
    </Modal>
  );
};
export default ChangePhoneModal;

const ModalContainer = styled.div`
  padding: 24px 24px 0px 24px;
  width: 100%;
`;
const StyledCurrentPhoneWrapper = styled.div`
  background: ${theme.colors.gray7};
  border: 1px solid #efefef;
  border-radius: 4px;
  padding: 18px 24px;
  display: flex;
  flex-wrap: nowrap;
  margin-bottom: 24px;
`;
const StyledTitle = styled.div`
  ${theme.typo.heading.b14};
  margin-right: 108px;
`;
const StyledPhone = styled.div`
  ${theme.typo.body.r14};
`;

const StyledPhoneAuthWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
`;
const StyledButtonWrapper = styled.div`
  margin-left: 8px;
`;
